import type { RequestRatingDetailResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { requestKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetRequestRating(requestId: null | number) {
  return useQuery<RequestRatingDetailResponse>({
    enabled: requestId != null,
    queryFn: () => apiClient.url(`/requests/${requestId}/rating`).get().json(),
    queryKey: requestKeys.rating(requestId ?? 0),
    retry: (failureCount, error) =>
      (error as { status?: number }).status !== 404 && failureCount < 3,
  });
}
